import { DocumentSubTypeEnum, DocumentTypeEnum } from '../../../utilities/DbConstants';
import { NoteTypes, StrategyTypes } from '../../../utilities/Constants';

import { INoteModel } from '../../../interfaces/INote';

const noteTypeToDocumentTypeMap: Record<number, number> = {
    [NoteTypes.CaseNote]: DocumentTypeEnum.CaseNote,
    [NoteTypes.ZoneNote]: DocumentTypeEnum.ZoneNote,
    [NoteTypes.StrategyNote]: DocumentTypeEnum.StrategyNote,
    [NoteTypes.PackageSettlementNote]: DocumentTypeEnum.PackageDealNote,
    [NoteTypes.StrategySignificantChange]: DocumentTypeEnum.StrategyNote,
};

export const getDocumentTypeId = (note: INoteModel): number => {
    return note.type?.id != null ? (noteTypeToDocumentTypeMap[note.type.id] ?? -1) : -1;
};

export const getDocumentSubTypeId = (note: INoteModel): number | undefined => {
    if (note.type?.id === NoteTypes.StrategyNote) {
        return getDocumentSubTypeForStrategy(note.originStrategyType);
    }

    return undefined;
};

const getDocumentSubTypeForStrategy = (strategyTypeId: number | undefined): number | undefined => {
    switch (strategyTypeId) {
        case StrategyTypes.Experts.Value:
            return DocumentSubTypeEnum.Expert;
        case StrategyTypes.Jurisdiction.Value:
            return DocumentSubTypeEnum.Jurisdiction;
        case StrategyTypes.LocalCounsel.Value:
            return DocumentSubTypeEnum.LocalCounsel;
        case StrategyTypes.PlaintiffsFirm.Value:
            return DocumentSubTypeEnum.PlaintiffsFirm;
        case StrategyTypes.Projects.Value:
            return DocumentSubTypeEnum.Project;
    }

    return undefined;
};
